import app from "nystem";
import { Button, Link } from "nystem-components";

const ViewLinkButton = ({ model, view }) => {
  const { title, className } = model;
  let { href = "" } = model;
  if (href[href.length - 1] === "/" && view.value) href += view.value._id;

  return (
    <Button
      className={className}
      to={href}
      match={model.match}
      title={title || ""}
      Component={Link}
    >
      {app.t(model.text)}
    </Button>
  );
};
export default ViewLinkButton;
